import React, { Component } from "react";
import { NavBar, SideBar, Footer } from "../../components";
import "react-toastify/dist/ReactToastify.css";
import PouchDB from "pouchdb";
import PouchdbFind from "pouchdb-find";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { cepMask } from "../../mask";
import axios from "axios";
import clienteModel from "../../models/cliente";
import queryString from "query-string";
PouchDB.plugin(PouchdbFind);

export default class EnderecoEditar extends Component {
  constructor(props) {
    super(props);
    this.getDefaultEndereco = this.getDefaultEndereco.bind(this);
    this.notificar = this.notificar.bind(this);
    this.buscarEndereco = this.buscarEndereco.bind(this);
    this.handleChangeInputNovoEndereco =
      this.handleChangeInputNovoEndereco.bind(this);
    this.validarEndereco = this.validarEndereco.bind(this);
    this.salvarEndereco = this.salvarEndereco.bind(this);

    this.state = {
      db: null,
      errorsEndereco: {
        cep: false,
        bairro: false,
        cep: false,
        cidade: false,
        endereco: false,
        estado: false,
        numero: false,
      },
      novoEndereco: this.getDefaultEndereco(false),
      exibirLoading: false,
      pedido: null,
      idCliente: queryString.parse(this.props.location.search).id,
    };
  }

  async componentDidMount() {
    let db = await new PouchDB(this.props.getBaseUrlBanco(), {
      auth: this.props.getUserBanco(),
      skipSetup: true,
    });
    this.setState(
      {
        db: db,
      },
      async () => {
        let pedido = JSON.parse(localStorage.getItem("pedido"));
        this.setState({ pedido });
      }
    );
  }

  getDefaultEndereco(sl) {
    return {
      idIntegracao: null,
      idIntegracaoRandom: Math.random(),
      endereco: "",
      bairro: "",
      cidade: "",
      estado: "",
      cep: "",
      numero: "",
      complemento: "",
      principal: sl,
    };
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  async buscarEndereco() {
    let cep = this.state.novoEndereco.cep;

    if (cep === "") return false;

    cep = cep.replace(".", "");
    cep = cep.replace("-", "");

    if (cep.length < 8) {
      this.notificar("warning", "Cep digitado é inválido");
      return false;
    }

    if (!navigator.onLine) {
      this.notificar(
        "warning",
        "Conecte a uma rede de dados para buscar informações do CEP!"
      );
      return false;
    }

    this.setState({ exibirLoading: true }, async () => {
      await axios
        .get(`https://viacep.com.br/ws/${cep}/json`)
        .then((response) => {
          console.log(response);
          let data = response.data;

          if (data.erro) {
            this.notificar(
              "warning",
              "Não foi possível localizar informação com base no CEP digitado!"
            );
            this.setState({ exibirLoading: false });
            return false;
          }

          let novoEndereco = this.state.novoEndereco;
          novoEndereco.endereco = data.logradouro.toString().toUpperCase();
          novoEndereco.bairro = data.bairro.toString().toUpperCase();
          novoEndereco.cidade = data.localidade.toString().toUpperCase();
          novoEndereco.estado = data.uf.toString().toUpperCase();

          this.setState({ novoEndereco, exibirLoading: false });
        })
        .catch((error) => {
          this.notificar(
            "warning",
            "Ocorreu um erro ao tentar buscar as informações."
          );
          this.setState({ exibirLoading: false });
        });
    });
  }

  handleChangeInputNovoEndereco(e, tipo) {
    let value = e.target.value;

    if (tipo === "cep") {
      value = cepMask(value);
    }

    value = value.toString().toUpperCase();

    this.setState({
      novoEndereco: { ...this.state.novoEndereco, [tipo]: value },
    });
  }

  validarEndereco() {
    let errorsLocal = this.state.errorsEndereco;
    let endereco = this.state.novoEndereco;
    let camposObrigatorios = [
      "bairro",
      "cep",
      "cidade",
      "endereco",
      "estado",
      "numero",
    ];

    let valido = true;

    for (let campo of camposObrigatorios) {
      if (endereco[campo] === "") {
        errorsLocal[campo] = true;
        valido = false;
      } else {
        errorsLocal[campo] = false;
      }
    }

    this.setState({ errorsEndereco: errorsLocal });
    return valido;
  }

  async salvarEndereco() {
    if (!this.validarEndereco()) {
      this.notificar("warning", "Preencha todos os dados corretamente");
      return false;
    }

    let pedido = this.state.pedido;
    let enderecosCliente = pedido.cliente.enderecos;
    let novoEndereco = this.state.novoEndereco;

    if (novoEndereco.principal) {
      for (let endereco of enderecosCliente) {
        endereco.principal = false;
      }
    }

    enderecosCliente.push(novoEndereco);
    pedido.cliente.enderecos = enderecosCliente;
    localStorage.setItem("pedido", JSON.stringify(pedido));

    let cliente = await clienteModel.findById(
      this.state.db,
      this.state.idCliente
    );
    let enderecosClienteBanco = cliente.enderecos;

    if (novoEndereco.principal) {
      for (let endereco of enderecosClienteBanco) {
        endereco.principal = false;
      }
    }

    enderecosClienteBanco.push(novoEndereco);
    cliente.enderecos = enderecosClienteBanco;
    await clienteModel.update(this.state.db, cliente);

    this.notificar("success", "Endereço cadastrado com sucesso");
    this.props.history.push(localStorage.getItem("urlAnterior"));
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar title="Cadastrar Endereço" />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"novoPedido"} />
            <div className="main-panel">
              <div className="content-wrapper">
                {/* <TitleAndDescription
                  title={`Cadastrar Pedido`}
                  description="Adicionar um novo pedido"
                /> */}

                <div className="row font-size-13">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body dashboard-tabs p-0">
                        <div className="tab-content py-0 px-0">
                          <div
                            className="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                            aria-labelledby="overview-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              <div
                                style={{
                                  padding: "15px",
                                  float: "left",
                                  width: "100%",
                                }}
                              >
                                <div
                                  className="row"
                                  style={{ padding: "15px" }}
                                >
                                  <div className="col-2 float-left pd-pedido">
                                    <div className="form-group">
                                      <label>Tipo</label>
                                      <select
                                        className="form-control font-size-13"
                                        value={
                                          this.state.novoEndereco.principal
                                        }
                                        disabled={true}
                                        onChange={(e) =>
                                          this.setState({
                                            novoEndereco: {
                                              ...this.state.novoEndereco,
                                              principal:
                                                e.target.value === "true"
                                                  ? true
                                                  : false,
                                            },
                                          })
                                        }
                                      >
                                        <option value="false">
                                          Secundário
                                        </option>
                                        <option value="true">Principal</option>
                                      </select>
                                    </div>
                                  </div>

                                  <div className="col-2 float-left pd-pedido">
                                    <div
                                      className="form-group float-left"
                                      style={{ width: "100%" }}
                                    >
                                      <label>CEP</label>
                                      <input
                                        type="text"
                                        value={this.state.novoEndereco.cep}
                                        onChange={(e) =>
                                          this.handleChangeInputNovoEndereco(
                                            e,
                                            "cep"
                                          )
                                        }
                                        className={`form-control font-size-13 ${
                                          this.state.errorsEndereco.cep
                                            ? "input-error"
                                            : ""
                                        }`}
                                        onBlur={this.buscarEndereco}
                                      />
                                    </div>
                                    <div
                                      style={{
                                        position: "absolute",
                                        right: "45px",
                                        top: "28px",
                                      }}
                                    >
                                      {this.state.exibirLoading && (
                                        <div
                                          id="loading-bar-spinner2"
                                          className="spinner"
                                        >
                                          <div className="spinner-icon"></div>
                                        </div>
                                      )}
                                    </div>
                                  </div>

                                  <div className="col-3 float-left pd-pedido">
                                    <div className="form-group">
                                      <label>Rua</label>
                                      <input
                                        type="text"
                                        value={this.state.novoEndereco.endereco}
                                        onChange={(e) =>
                                          this.handleChangeInputNovoEndereco(
                                            e,
                                            "endereco"
                                          )
                                        }
                                        className={`form-control font-size-13 ${
                                          this.state.errorsEndereco.endereco
                                            ? "input-error"
                                            : ""
                                        }`}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-1 float-left pd-pedido">
                                    <div className="form-group">
                                      <label>Número</label>
                                      <input
                                        type="text"
                                        value={this.state.novoEndereco.numero}
                                        onChange={(e) =>
                                          this.handleChangeInputNovoEndereco(
                                            e,
                                            "numero"
                                          )
                                        }
                                        className={`form-control font-size-13 ${
                                          this.state.errorsEndereco.numero
                                            ? "input-error"
                                            : ""
                                        }`}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-2 form-group pd-pedido">
                                    <label>Complemento</label>
                                    <input
                                      type="text"
                                      value={
                                        this.state.novoEndereco.complemento
                                      }
                                      onChange={(e) =>
                                        this.handleChangeInputNovoEndereco(
                                          e,
                                          "complemento"
                                        )
                                      }
                                      className="form-control font-size-13"
                                    />
                                  </div>
                                  <div className="col-2 form-group pd-pedido">
                                    <label>Bairro</label>
                                    <input
                                      type="text"
                                      value={this.state.novoEndereco.bairro}
                                      onChange={(e) =>
                                        this.handleChangeInputNovoEndereco(
                                          e,
                                          "bairro"
                                        )
                                      }
                                      className={`form-control font-size-13 ${
                                        this.state.errorsEndereco.bairro
                                          ? "input-error"
                                          : ""
                                      }`}
                                    />
                                  </div>
                                  <div className="col-2 float-left pd-pedido">
                                    <div className="form-group">
                                      <label>Cidade</label>
                                      <input
                                        type="text"
                                        value={this.state.novoEndereco.cidade}
                                        onChange={(e) =>
                                          this.handleChangeInputNovoEndereco(
                                            e,
                                            "cidade"
                                          )
                                        }
                                        className={`form-control font-size-13 ${
                                          this.state.errorsEndereco.cidade
                                            ? "input-error"
                                            : ""
                                        }`}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-2 float-left pd-pedido">
                                    <div className="form-group">
                                      <label>Estado</label>
                                      <select
                                        className={`form-control font-size-13 ${
                                          this.state.errorsEndereco.estado
                                            ? "input-error"
                                            : ""
                                        }`}
                                        value={this.state.novoEndereco.estado}
                                        onChange={(e) =>
                                          this.handleChangeInputNovoEndereco(
                                            e,
                                            "estado"
                                          )
                                        }
                                      >
                                        <option value="">Selecione</option>
                                        <option value="AC">AC</option>
                                        <option value="AL">AL</option>
                                        <option value="AP">AP</option>
                                        <option value="AM">AM</option>
                                        <option value="BA">BA</option>
                                        <option value="CE">CE</option>
                                        <option value="DF">DF</option>
                                        <option value="ES">ES</option>
                                        <option value="GO">GO</option>
                                        <option value="MA">MA</option>
                                        <option value="MT">MT</option>
                                        <option value="MS">MS</option>
                                        <option value="MG">MG</option>
                                        <option value="PA">PA</option>
                                        <option value="PB">PB</option>
                                        <option value="PR">PR</option>
                                        <option value="PE">PE</option>
                                        <option value="PI">PI</option>
                                        <option value="RJ">RJ</option>
                                        <option value="RN">RN</option>
                                        <option value="RS">RS</option>
                                        <option value="RO">RO</option>
                                        <option value="RR">RR</option>
                                        <option value="SC">SC</option>
                                        <option value="SP">SP</option>
                                        <option value="SE">SE</option>
                                        <option value="TO">TO</option>
                                      </select>
                                    </div>
                                  </div>

                                  <div className="col-12 pd-pedido">
                                    <button
                                      className="btn btn-success"
                                      // onClick={() =>
                                      //   //this.cadastrarPedido("orcamento")
                                      // }
                                      onClick={this.salvarEndereco}
                                    >
                                      Cadastrar
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
